import React, { useContext } from 'react'
import { ErrorBoundary } from '@sentry/gatsby'
import '../styles/global.scss'
import Button from './Button/Button'
import { IdentityContext } from '../contexts/IdentityContext'

function FallBack({ error, resetError}) {
  const {supportEmail} = useContext(IdentityContext);
  return (
    <div className="error-alert">
      <p className="error-title">Something went wrong</p>
      <pre className="error-message">{error.message}</pre>
      <p>
        If the issue persists, contact support at{" "}
        <a href={`mailto:${supportEmail}`}>{supportEmail}</a>.
      </p>
      <Button onClick={resetError}>Try again</Button>
    </div>
  );
}

const ErrorBoundaryContainer = ({ children }) => <ErrorBoundary fallback={FallBack}>{children}</ErrorBoundary>

export default ErrorBoundaryContainer